// src/stores/adminStore.js
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

export const useAdminStore = defineStore('adminStore', () => {
  const isAdmin = ref(false);
  const auth = getAuth();

const checkAdminStatus = async () => {
  const user = auth.currentUser;

  if (user) {
    const db = getFirestore();
    const docRef = doc(db, 'admins', 'cPoCyp55VWnWvGWDSkjy');
    
    try {
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        isAdmin.value = data.userIds.includes(user.uid);
        return isAdmin.value;
      } else {
        isAdmin.value = false;
        return false;
      }
    } catch (error) {
      console.error('Error checking admin status:', error);
      isAdmin.value = false;
      return false;
    }
  } else {
    isAdmin.value = false;
    return false;
  }
};


  // Call checkAdminStatus on store initialization
  checkAdminStatus();

  onAuthStateChanged(auth, user => {
    if (user) {
      checkAdminStatus()
    } else {
      isAdmin.value = false
    }
  })

  return {
    isAdmin,
    checkAdminStatus,
  };
});
